import {
  AgentRotationRangeTypeEnum,
  LeadsClassTypesEnum,
} from "../../../Enums";

export const buildQueryBody = (formValues) => {
  const { addRotationForm, schemaSettingsForm } = formValues;
  const contactClasses = {
    normal: {
      contactClassId: 68,
      contactClassName: "Normal",
    },
    viip: {
      contactClassId: 70,
      contactClassName: "VVIP",
    },
    vip: {
      contactClassId: 69,
      contactClassName: "VIP",
    },
  };

  const currentContactClasses = [];
  const leadClasses = [];
  if (addRotationForm.vip) currentContactClasses.push(contactClasses.vip);
  if (addRotationForm.normal) currentContactClasses.push(contactClasses.normal);
  if (addRotationForm.viip) currentContactClasses.push(contactClasses.viip);
  if (addRotationForm.buyer) leadClasses.push(LeadsClassTypesEnum.buyer);
  if (addRotationForm.tenant) leadClasses.push(LeadsClassTypesEnum.tenant);
  return {
    rotationSchemeId: null,
    label: addRotationForm.label,
    order: String(addRotationForm.order),
    isForOwnerLeads: false,
    rotationPreferredLanguages: addRotationForm.rotationPreferredLanguages.map(
      ({ languageId }) => ({
        languageId,
      })
    ),
    rotationSchemeCountries: addRotationForm.rotationSchemeCountries,
    rotationSchemeCities: addRotationForm.rotationSchemeCities,
    rotationSchemeCommunities: addRotationForm.rotationSchemeCommunities,

    rotationSchemeDistricts: addRotationForm.rotationSchemeDistricts,
    rotationSchemeSubCommunities: addRotationForm.rotationSchemeSubCommunities,

    rotationSchemeUnitTypes: addRotationForm.rotationSchemeUnitTypes,
    rotationSchemeRanges: [
      {
        startValue: addRotationForm.priceRange[0],
        endValue: addRotationForm.priceRange[1],
        agentRotationRangeTypeId: AgentRotationRangeTypeEnum.PriceRange.key,
      },
      {
        startValue: addRotationForm.size[0],
        endValue: addRotationForm.size[1],
        agentRotationRangeTypeId: AgentRotationRangeTypeEnum.Size.key,
      },
      {
        startValue: addRotationForm.bathrooms[0],
        endValue: addRotationForm.bathrooms[1],
        agentRotationRangeTypeId: AgentRotationRangeTypeEnum.Bathroom.key,
      },
      {
        startValue: addRotationForm.bedrooms[0],
        endValue: addRotationForm.bedrooms[1],
        agentRotationRangeTypeId: AgentRotationRangeTypeEnum.Bedroom.key,
      },
    ],
    rotationSchemaContactCLasses: currentContactClasses,
    rotationSchemeMedias: addRotationForm.rotationSchemeMedias,

    rotationSchemaDeveloperIds: [],
    rotationSchemaReferredBys: addRotationForm.rotationSchemaReferredBys,

    rotationSchemeProperties: addRotationForm.rotationSchemeProperties,
    rotationSchemaLeadsType: leadClasses.map((item) => ({
      leadClass: item.key,
    })),
    rotationSchemaMethodOfContacts:
      addRotationForm.rotationSchemaMethodOfContacts,
    propertyCampaignIds: addRotationForm.propertyCampaignIds.map(
      (item) => item.propertyCampaignId
    ),
    rotationSchemeTeams: schemaSettingsForm.rotationSchemeTeams,
    rotationSchemeBranches: schemaSettingsForm.rotationSchemeBranches,
    sla: schemaSettingsForm.sla,
    isActive: addRotationForm.isActive,
    isBulk: addRotationForm.isBulk,
    rotationSchemeLeadDistributionType:
      schemaSettingsForm.rotationSchemeLeadDistributionType,
    isOverrideLeadCapacitySettingEnabled:
      schemaSettingsForm.isOverrideLeadCapacitySettingEnabled === "true",
    rotationSchemeCourses: schemaSettingsForm.rotationSchemeCourses,
  };
};
